import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { ILocationForList } from "@services/locations";
import { MODALS_ENUM } from "@constants/Modals";
import cn from "classnames";
import styles from "./AddLocation.module.scss";
import { useAddLocationControl } from "./useAddLocationControl";
import Error from "@components/global/new/Error/Error";
import CoordsMap from "./CoordsMap/CoordsMap";

import map from "@assets/img/new/example_map.png";
import { Input } from "@components/global/new/Input/Input";
import { Button } from "antd";

export interface IAddLocatinProps extends CommonModalPropsI {
  location: ILocationForList;
}

function AddLocation({ location, ...props }: IAddLocatinProps) {
  const control = useAddLocationControl({ location, ...props });
  const formatMessage = props.formatMessage;
  return (
    <div className={styles.wrapper}>
      <CoordsMap
        coords={control.mapCoords}
        getCoords={control.setMapCoords}
        openMapModal={control.openMapModal}
        setOpenMapModal={control.setOpenMapModal}
      />
      <Title>
        {formatMessage({
          id: !location ? "modal.location.title" : "modal.location.title_edit",
        })}
      </Title>

      <form className={styles.content} onSubmit={control.onSubmit}>
        <Input
          label={formatMessage({ id: "modal.location.name" })}
          type='text'
          id='name'
          value={location?.Name}
        //isError={!!control.errorsStr?.fill}
        />
        <Input
          label={formatMessage({ id: "modal.location.id" })}
          type='text'
          id='loc_id'
          value={location?.Code}
          disabled={location?.Code ? true : false}
          readOnly={location?.Code ? true : false}
        //isError={!!control.errorsStr?.ownError || !!control.errorsStr?.fill}
        />

        <Input
          label={formatMessage({ id: "modal.location.address" })}
          type='text'
          id='address'
          value={location?.Address}
        />
        <div className={styles.coords}>
          <div className={styles.label_wrapper}>
            <label
              className={cn(styles.label, {
                // [styles.error]: !!control.errorsStr && !control.mapCoords,
              })}
            >
              {formatMessage({ id: "modal.location.coords" })}
            </label>
            <span
              onClick={() => control.setOpenMapModal(true)}
              className={styles.map}
            />
          </div>
          <p>{control.mapCoords?.toString()}</p>
        </div>

        <div className={styles.area}>
          <label>{formatMessage({ id: "modal.location.notes" })}</label>
          <textarea id='notes' defaultValue={location?.Notes} />
        </div>

        {control.errorsStr && <Error errors={control.errorsStr} />}

        <div className={styles.btns}>
          <Button onClick={props.handleClose} htmlType='button'>
            {formatMessage({ id: "modal.location.btn.cancel" })}
          </Button>
          <Button htmlType='submit' type="primary">
            {formatMessage({ id: "modal.location.btn.save" })}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default WithModal(MODALS_ENUM.ADD_LOCAION, AddLocation);
